export const newPageNotificationModal = {
	title: "Mais segurança para o seu fiscal!",
	content:
		"Agora, sempre que um cadastro fiscal for criado ou alterado pela Zig,",
	contentEmphasis:
		"você poderá revisar e validar os dados antes que eles sejam utilizados.",
	primaryActionLabel: "Ver novidades",
};
